<svg xmlns="http://www.w3.org/2000/svg" width="394" height="395.5" viewBox="0 0 394 395.5">
   <g id="Group_53" data-name="Group 53" transform="translate(-1896 -637)">
      <g id="Group_22" data-name="Group 22" transform="translate(1896 813.237)">
         <g id="Group_21" data-name="Group 21">
            <line id="Line_7" data-name="Line 7" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
         </g>
      </g>
      <g id="Group_49" data-name="Group 49" transform="translate(1896 977.817)">
         <g id="Group_21-2" data-name="Group 21">
            <line id="Line_7-2" data-name="Line 7" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
         </g>
      </g>
      <g id="Group_52" data-name="Group 52" transform="translate(1896 1031)">
         <g id="Group_21-3" data-name="Group 21">
            <line id="Line_7-3" data-name="Line 7" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
         </g>
      </g>
      <g id="Group_24" data-name="Group 24" transform="translate(1896 760.053)">
         <g id="Group_23" data-name="Group 23">
            <line id="Line_8" data-name="Line 8" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
         </g>
      </g>
      <g id="Group_50" data-name="Group 50" transform="translate(1896 924.633)">
         <g id="Group_23-2" data-name="Group 23">
            <line id="Line_8-2" data-name="Line 8" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
         </g>
      </g>
      <g id="Group_26" data-name="Group 26" transform="translate(1896 706.87)">
         <g id="Group_25" data-name="Group 25">
            <line id="Line_9" data-name="Line 9" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
         </g>
      </g>
      <g id="Group_51" data-name="Group 51" transform="translate(1896 871.45)">
         <g id="Group_25-2" data-name="Group 25">
            <line id="Line_9-2" data-name="Line 9" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
         </g>
      </g>
      <g id="Group_28" data-name="Group 28" transform="translate(1896 653.687)">
         <g id="Group_27" data-name="Group 27">
            <line id="Line_10" data-name="Line 10" x2="394" fill="none" stroke="#ddd" stroke-width="3" />
         </g>
      </g>
      <g id="Group_36" data-name="Group 36" transform="translate(1913.203 706.87)">
         <g id="Group_35" data-name="Group 35">
            <g id="Group_34" data-name="Group 34">
               <g id="Group_33" data-name="Group 33">
                  <g id="Group_32" data-name="Group 32">
                     <path
                        id="Path_4"
                        data-name="Path 4"
                        d="M19.954,111.4,199.884,0,379.813,111.4"
                        transform="translate(-19.954)"
                        fill="none"
                        stroke="#b1c4e2"
                        stroke-width="5.5"
                     />
                  </g>
               </g>
            </g>
         </g>
      </g>
      <g id="Group_41" data-name="Group 41" transform="translate(1913.203 871.45)">
         <g id="Group_40" data-name="Group 40">
            <g id="Group_39" data-name="Group 39">
               <g id="Group_38" data-name="Group 38">
                  <g id="Group_37" data-name="Group 37">
                     <path
                        id="Path_5"
                        data-name="Path 5"
                        d="M19.954,138l179.929,88.467,179.929-44.234"
                        transform="translate(-19.954 -138)"
                        fill="none"
                        stroke="#6b9ad2"
                        stroke-width="5.5"
                     />
                  </g>
               </g>
            </g>
         </g>
      </g>
      <g id="Group_46" data-name="Group 46" transform="translate(1913.203 722.606)">
         <g id="Group_45" data-name="Group 45">
            <g id="Group_44" data-name="Group 44">
               <g id="Group_43" data-name="Group 43">
                  <g id="Group_42" data-name="Group 42">
                     <path
                        id="Path_6"
                        data-name="Path 6"
                        d="M19.954,248.027l179.929-67.342L379.813,46"
                        transform="translate(-19.954 -46)"
                        fill="none"
                        stroke="#597dad"
                        stroke-width="5.5"
                     />
                  </g>
               </g>
            </g>
         </g>
      </g>
      <rect
         id="Rectangle_6"
         data-name="Rectangle 6"
         width="394"
         height="394"
         transform="translate(1896 637)"
         fill="none"
      />
   </g>
</svg>
